module.exports = __webpack_public_path__ + "img/ban2.88064f67.jpg";